import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { retrieveEntries, retrieveGames } from "../api/api";
import { SubmittedEntry } from "./entries/SubmittedEntry";
import { WeekSelector } from "./weeks/WeekSelector";

function Results(props) {
    const [selectedWeek, setSelectedWeek] = useState(null);
    const [entriesForWeek, setEntriesForWeek] = useState([]);
    const [games, setGames] = useState([]);

    const findUser = (id) => {
        if (!props.users || props.users.length === 0) {
            return null;
        }
        for (let i = 0; i < props.users.length; i++) {
            if (props.users[i].id === id) {
                return props.users[i];
            }
        }
        return null;
    }

    useEffect(() => {
        if (selectedWeek) {
            retrieveEntries(selectedWeek.number).then((entries) => {
                setEntriesForWeek(entries);
            });
        }
    }, [selectedWeek]);

    useEffect(() => {
        if (!selectedWeek) {
            return;
        }

        retrieveGames(selectedWeek.number).then((games) => { setGames(games); });
    }, [selectedWeek]);

    useEffect(() => {
        if (props.weeks && props.weeks.length > 0 && selectedWeek) {
            for (let i = 0; i < props.weeks; i++) {
                if (selectedWeek.year === props.weeks[i].year && selectedWeek.number === props.weeks[i].number && selectedWeek !== props.weeks[i]) {
                    setSelectedWeek(props.weeks[i]);
                }
            }
        }
    }, [props.weeks, selectedWeek]);

    const renderSubmittedEntries = () => {
        if (!entriesForWeek) {
            return <></>;
        }

        if (!games || games.length === 0 || games[0].week_number !== selectedWeek.number) {
            return <></>;
        }

        let submittedEntries = entriesForWeek.filter((e) => { return e.status !== 'PENDING'; })
        if (submittedEntries.length === 0) {
            return <></>;
        }

        return (
            <div className="row">
                <div className="column">
                    <Table striped borderless variant="dark" className="w-auto transparent">
                        <tbody>
                            {submittedEntries.map((e) => {
                                return <SubmittedEntry key={e.id} entry={e} games={games} user={findUser(e.user_id)} />;
                            })}
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }

    const selectedWeekDeadline = selectedWeek && new Date(Date.parse(selectedWeek.deadline));
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="column">
                        <h1 className="py-4">Weekly Results</h1>
                        <table className="mb-4">
                            <tbody>
                                <tr>
                                    <td><WeekSelector id="entry-week-selector" weeks={props.weeks} week={selectedWeek} setWeek={setSelectedWeek} noFutureWeeks={true} /></td>
                                    {selectedWeek && <td className="ps-5"><div className="h5">Total Prize Pool: ${selectedWeek.pot}</div></td>}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {selectedWeek && Date.now() < selectedWeekDeadline.getTime() &&
                    <div className="row">
                        <div className="column">
                            <p className="lead py-4">Weekly Entries will posted after the submisssion deadline ({selectedWeekDeadline.toLocaleString('en-US', { weekday: 'long' }) + ' ' + selectedWeekDeadline.toLocaleString()}).</p>
                        </div>
                    </div>}
                {selectedWeek && Date.now() >= selectedWeekDeadline.getTime() && renderSubmittedEntries()}
            </div>
        </>
    );
}

export default Results;